var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-link-list"},[_vm._l((_vm.socials),function(social,index){return _c('social-link',_vm._b({key:index},'social-link',social,false))}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }